import axios from "axios";
import { getToken } from "./auth.api";

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL });

api.interceptors.request.use(config => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/* Retorna todos os tickets com status "Retrabalhar".
   O backend também marca automaticamente o campo customizado
   "Retrabalho = Sim" para quaisquer tickets ainda não marcados. */
export async function getRetrabalhos() {
  const { data } = await api.get("/retrabalhos");
  return Array.isArray(data) ? data : (data?.tickets || []);
}

/* Adiciona um ticket de retrabalho na sprint.
   eh_programado_ativo = true → ticket já estava na programação desta sprint:
     mantém Programado=Sim, NÃO marca Emergência.
   eh_programado_ativo = false (padrão) → retrabalho puro:
     marca Emergência=Sim e Programado=Não. */
export async function adicionarNaSprint(ticketId, { versao, grupo_entrega, programacao_tipo, desenvolvedor, eh_programado_ativo }) {
  const { data } = await api.post("/retrabalhos/sprint", {
    ticket_id: ticketId,
    versao,
    grupo_entrega,
    programacao_tipo,
    desenvolvedor,
    eh_programado_ativo: eh_programado_ativo ?? false,
  });
  return data;
}
